import { User } from "../../store/types";

/** Пользователи для выпадающих списков: «Фамилия Имя — почта». */
export const toUserOptions = (users: User[] | null | undefined) =>
  (users ?? [])
    .map((user) => ({
      label: `${`${user.lastName ?? ""} ${user.name ?? ""}`.trim() || "Без имени"} — ${user.email}`,
      value: user.id,
    }))
    .sort((a, b) => a.label.localeCompare(b.label, "ru"));

export const formatDateTime = (value: string | null | undefined) =>
  value ? new Date(value).toLocaleString("ru-RU") : "—";

export const instancePath = (id: string) => `/instances/${encodeURIComponent(id)}`;
